export default function() {}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-shape/src/noop.js
// module id = 28
// module chunks = 0